import { formatDateForAPI } from "utils/utils";
import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { createTicket } from "./api";
import { queryClient } from "utils/react-query";

function buildPayload(values) {
    if (!values || typeof values !== "object") return {};

    const { ...rest } = values;

    return {
        ...Object.fromEntries(
            Object.entries(rest).filter(
                ([_, v]) => v !== "" && v !== undefined && v !== null
            )
        ),
        due_date: formatDateForAPI(values.due_date) || null,
        status: values.status || "open",
    };
}

export function useCreateTicket() {
    return useMutation({
        mutationFn: async ({ values }) => {
            const payload = buildPayload(values);
            const response = await createTicket({ item: payload });
            return response;
        },
        onSuccess: () => {
            toast.success("Ticket Created Successfully");
            queryClient.invalidateQueries();
        },
        onError: (error) => {
            toast.error(error.message);
            console.error(error);
        },
    });
}
